/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConfidentialInputs */

const en_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Confidential`)
};

const es_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Confidencial`)
};

const fr_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Confidentiel`)
};

const de_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Vertraulich`)
};

const ja_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 社外秘`)
};

const zh_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 机密`)
};

const ar_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 سري`)
};

const id_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Rahasia`)
};

const it_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Riservato`)
};

const ru_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Конфиденциально`)
};

const pt_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 Confidencial`)
};

const ko_confidential = /** @type {(inputs: ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔐 기밀`)
};

/**
* | output |
* | --- |
* | "🔐 Confidential" |
*
* @param {ConfidentialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const confidential = /** @type {((inputs?: ConfidentialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConfidentialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confidential(inputs)
	if (locale === "es") return es_confidential(inputs)
	if (locale === "fr") return fr_confidential(inputs)
	if (locale === "de") return de_confidential(inputs)
	if (locale === "ja") return ja_confidential(inputs)
	if (locale === "zh") return zh_confidential(inputs)
	if (locale === "ar") return ar_confidential(inputs)
	if (locale === "id") return id_confidential(inputs)
	if (locale === "it") return it_confidential(inputs)
	if (locale === "ru") return ru_confidential(inputs)
	if (locale === "pt") return pt_confidential(inputs)
	return ko_confidential(inputs)
});